import { put, call, take, fork } from 'redux-saga/effects'
import { cardLinkDeleteService } from '../../api/card'
import { cardLinkDeleteSuccess } from '../../reducers/card/action'
import { CARD_LINK_DELETE } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* cardLinkDeleteFlow(payload) {
  try {
    const { id, questionId, callback } = payload
    yield call(cardLinkDeleteService, id)

    yield put(cardLinkDeleteSuccess(id, questionId))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardLinkDeleteWatcher() {
  while (true) {
    const action = yield take(CARD_LINK_DELETE)
    const { payload } = action

    yield fork(generalSaga, cardLinkDeleteFlow, payload)
  }
}
